export enum EAutoSave {
  LOADING = 'loading',
  SAVED = 'saved',
  ERROR = 'error',
}
